import {Injectable} from '@angular/core';
import {Response, Headers} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Enterprise} from '../models/enterprise';
import 'rxjs/add/operator/map';

@Injectable()
export class EnterpriseService {

  private enterpriseUrl: string = `${ environment.apiRoot }/company/`;

  constructor(private http: HttpAuth) { }

  public getEnterprise(): Observable<Enterprise> {
    return this.http.get(this.enterpriseUrl)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putEnterprise(enterprise:Enterprise): Observable<Enterprise> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.enterpriseUrl,enterprise,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/enterprise.service.ts